import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;
  margin-top: 25px;
`;

export const CheckboxLabel = styled.label`
  font-weight: 500;
  font-size: 14px;
  color: #3b3f5c;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
`;

export const DateRangeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: flex-start;

  @media (max-width: 768px) {
    align-items: center;
  }
`;

export const DateFieldsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 0.5rem;
  width: 110%;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const DateInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;

  .react-datepicker-wrapper {
    display: block;
  }

  input {
    height: 36px;
    width: 160px;
    padding-right: 30px;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    font-size: 14px;
    padding-left: 10px;
    background-color: #fff;

    &:disabled {
      background-color: #f5f5f5;
      cursor: not-allowed;
    }
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  white-space: nowrap;

  @media (max-width: 768px) {
    margin-left: 0;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 8px;
  }
`;

export const Separator = styled.span`
  font-size: 18px;
  margin: 0 4px;
  line-height: 36px;
`;

export const ShortcutButton = styled.button`
  height: 36px;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 0 10px;
  font-size: 15px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;

  &:hover {
    background-color: #f0f0f0;
  }

  &:disabled {
    background-color: #f2f2f2;
    color: #aaa;
    cursor: not-allowed;
  }
`;

export const ErrorFormMessageStyled = styled.span`
  color: red;
  font-size: 12px;
  line-height: 16px;
  min-height: 16px;
  margin-top: 4px;
  max-width: 160px;
  white-space: normal;
  word-break: break-word;
`;

export const CenteredErrorFormMessageStyled = styled(ErrorFormMessageStyled)`
  max-width: 100%;
  margin-top: 8px;
  text-align: center;
  width: 290px;
`;
